import SessionEventProto from "../session-event-proto"
import {SESSION_PROJECT_USERS_CHANGED} from "../../gd/bus/bus-event-type"
import DebugPerformance from "../../gd/utils/performance";

export default class EventProjectUsersResetByProjectRecursiveV3 extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    async process() {

        DebugPerformance.start("EventProjectUsersResetByProjectRecursiveV3")

        if (this.isDifferentCompany()) return

        if (!this.data) return

        // convert to standard json
        // json_build_object(
        //     'userId'        , pu.user_id,
        //     'projectId'     , pu.project_id,
        //     'projectRole'   , pu.project_role,
        //     'access'        , pu.access,
        //     'inheritance'   , pu.inheritance,
        //     'watchAll'      , pu.watch_all
        // )
        const dataNormalized = _.map(this.data, (record:any[])=>{
            return {
                'userId'        : record[0],
                'projectId'     : record[1],
                'projectRole'   : record[2],
                'access'        : record[3],
                'inheritance'   : record[4],
                'watchAll'      : !!record[5],
                'id'            : record[6],
                'teamId'        : record[7],
            }
        })

        // like original
        gd.session.projectUsers.resetForManyProjects(dataNormalized)

        gd.bus.triggerEvent(SESSION_PROJECT_USERS_CHANGED)

        DebugPerformance.stop("EventProjectUsersResetByProjectRecursiveV3")

    }

}
